import { motion } from 'framer-motion';
import { LayoutGridIcon, GemIcon, AwardIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
const KIT_NEGRO_URL = 'https://e04whn-0h.myshopify.com/products/kit-negro-premium-para-extensiones-de-pestanas';
const KIT_ROSADO_URL = 'https://e04whn-0h.myshopify.com/products/kit-rosado-premium-para-extensiones-de-pestanas';
const GOLD = '#C9A96E';
const benefits = [{
  icon: LayoutGridIcon,
  label: 'Organización inteligente'
}, {
  icon: GemIcon,
  label: 'Calidad Premium'
}, {
  icon: AwardIcon,
  label: 'Diseñado para profesionales'
}];
export function BrandClosing() {
  return <section className="relative overflow-hidden px-6 pt-28 pb-32" style={{
    background: 'linear-gradient(180deg, #ffffff 0%, #fdfbf7 45%, #f7f0e4 100%)'
  }} data-id="element-62" data-mp="2k7ns0amwzkvt">
      {/* Oversized brand signature watermark */}
      <img src={LOGO_URL} alt="" aria-hidden="true" className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] mix-blend-multiply opacity-[0.08] z-0" data-id="element-63" data-mp="2aars2tb3072v" />

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-64" data-mp="2rjoj4n8gugqj">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-65" data-mp="2rhbtrp0dp43g">
          <h2 className="font-serif text-3xl md:text-5xl text-luxury-black leading-tight mb-8" data-id="element-66" data-mp="3k5zki03wcloe">
            Tu talento merece herramientas a la altura de tu trabajo.
          </h2>

          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mx-auto mb-8 h-[1px] w-20 origin-center" style={{
          backgroundColor: GOLD
        }} data-id="element-67" data-mp="3a9egni3m5gm5" />

          <p className="text-base md:text-lg text-gray-600 font-sans font-light leading-relaxed max-w-2xl mx-auto mb-14" data-id="element-68" data-mp="23r7qjir3r6cz">
            Cada detalle transmite confianza. Organiza tus herramientas, protege
            tus materiales y proyecta una imagen profesional desde el primer
            momento con Alexa Beauty.
          </p>
        </motion.div>

        {/* Benefits */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-14 mb-16" data-id="element-69" data-mp="3rr33wcm4ys2r">
          {benefits.map(({
          icon: Icon,
          label
        }) => <div key={label} className="flex flex-col items-center gap-3" data-id="element-70" data-mp="38taca6gyq4ko">
              <Icon className="w-5 h-5" style={{
            color: GOLD
          }} data-id="element-71" data-mp="1c078e8nehri5" />
              <span className="text-xs tracking-[0.15em] uppercase text-luxury-dark font-sans" data-id="element-72" data-mp="1bzfjths80u1d">
                {label}
              </span>
            </div>)}
        </motion.div>

        {/* Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.35
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-73" data-mp="1eisplcvxz3be">
          <motion.a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto text-center bg-luxury-black hover:bg-luxury-dark text-white font-sans font-medium text-xs tracking-[0.2em] uppercase px-12 py-4 transition-colors duration-500" data-id="element-74" data-mp="1tbm4ox7axhfj">
            🖤 Comprar Kit Negro
          </motion.a>

          <motion.a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto text-center bg-rosado hover:bg-rosado-light text-white font-sans font-medium text-xs tracking-[0.2em] uppercase px-12 py-4 transition-colors duration-500" data-id="element-75" data-mp="2gy2h4c2ip6uz">
            🌸 Comprar Kit Rosado
          </motion.a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="mt-12 text-xs tracking-[0.3em] uppercase font-sans" style={{
        color: GOLD
      }} data-id="element-76" data-mp="2oidaiza0p2dw">
          Alexa Beauty · Brows And Lashes
        </motion.p>
      </div>
    </section>;
}